<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>機能</h1>
                            <h2>AI英文校正ツール<br/>
                                Trinkaの機能</h2>
                            <p>Trinka （トリンカ）は、世界初の学術論文・テクニカルライティングに特化した英文チェッカーです。英語の文法やスペルチェックにとどまらず、英文のトーンやスタイルも校正するその機能をご紹介します。</p>
                        </div>
                        <div class="top-banner-right">
                            <img src="../../../assets/images/FeaturesTopBanner.png" alt="文法 チェック" class="md50">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="advanceGrammerSpellCheck_section backgrondSecitons_outer mt-0">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-50 text-center">
                        <h2>AI英文校正ツールTrinkaの校正は
                            論文英語・アカデミックライティングの
                            精度を高めます</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>学術論文の英語には、明確さ、簡潔さ、格調、客観性、読みやすさなどが求められます。Trinkaは、それらすべてを改善し、ライティングの精度を高めます。</p>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="spellcheckGrammerCheck" class="carousel slide carousel-arrows" data-ride="carousel">
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators1 carousel-indicators">
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="0" class="active">
                                        <span></span>
                                        高度な
                                        文法修正
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="1">
                                        <span></span>
                                        構文
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="2">
                                        <span></span>
                                        単語の
                                        選択
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="3">
                                        <span></span>
                                        語法、
                                       文体
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="4">
                                        <span></span>
                                        アメリカ英語/イギリス英語
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="5">
                                        <span></span>
                                        文脈に
                                        即した
                                        スペル
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>高度な文法修正</h4>
                                    <p>他の校正ツールでは見つけられない3000種以上の複雑な文法ミスを検出。それにより、無駄のない明快な文章作成が可能になります。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">Neither the healthy individuals nor the patient
                                            <span class="wrongText">recognize</span>
                                            <span class="rightText">recognizes</span> the visual discrepancies.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>構文</h4>
                                    <p>内容をより分かりやすく伝えるために、文書の分野やジャンルに従って文の組み立てを修正します。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">The students don't enjoy
                                            <span class="wrongText">to go</span>
                                            <span class="rightText">going</span> over the same rules again and again.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>単語の選択</h4>
                                    <p>意味が明確でない単語を、より適切な単語に置き換えます。それにより、伝えたい内容がさらに正確に伝わります。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">One of the reasons is
                                            <span class="wrongText">because</span>
                                            <span class="rightText">that</span> the fabrication cost
                                            <span class="wrongText">for</span>
                                            <span class="rightText">of</span> steel members depends upon the material.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>語法、文体</h4>
                                    <p>語句を修正し、文体をフォーマルに整えます。読み手にしっかりと伝わる、はっきりとした英文が作れます。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">However, his method is novel and is
                                            <span class="wrongText">very much</span>
                                            <span class="rightText">considerably</span> different from the classical method.
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>アメリカ英語/イギリス英語</h4>
                                    <p>アメリカ/イギリス英語のいずれかを指定すれば、読者やジャーナルの投稿規程に合わせて表記を整えます。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">The upper limbs of the patient were
                                            <span class="wrongText">paralysed</span>
                                            <span class="rightText">paralyzed.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>文脈に即したスペル</h4>
                                    <p>文脈に即したスペルチェック機能では、その分野で使われる正しい単語/スペルでの校正を行います。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">The
                                            <span class="wrongText">Bonferoni</span>
                                            <span class="rightText">Bonferroni</span> test was used to check for statistical significance.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section backgrondSecitons_outer" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-xl-5">
                    <div class="spellcheck_heading">
                        <h2>AI英文校正ツールTrinkaの校正は
                            <br /> 論文英語・アカデミックライティングの
                            <br /> 精度を高めます
                        </h2>
                        <div class="HeadingSubLine"></div>
                        <p>学術論文の英語には、明確さ、簡潔さ、格調、客観性、読みやすさなどが求められます。Trinkaは、それらすべてを改善し、ライティングの精度を高めます。</p>
                    </div>
                </div>
                <div class="col-xl-7">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="spellcheckGrammerCheck" class="carousel slide" data-ride="carousel">
                            <!-- Indicators -->
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators">
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="0" class="active">
                                        <span></span>
                                        高度な
                                        <br />文法修正
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="1">
                                        <span></span>
                                        構文
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="2">
                                        <span></span>
                                        単語の
                                        <br />選択
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="3">
                                        <span></span>
                                        語法、
                                        <br />文体
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="4">
                                        <span></span>
                                        アメリカ英語/イギリス英語
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="5">
                                        <span></span>
                                        文脈に
                                        <br />即した
                                        <br />スペル
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>高度な文法修正</h4>
                                    <p>他の校正ツールでは見つけられない3000種以上の複雑な文法ミスを検出。それにより、無駄のない明快な文章作成が可能になります。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">Neither the healthy individuals nor the patient
                                            <span class="wrongText">recognize</span>
                                            <span class="rightText">recognizes</span> the visual discrepancies.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>構文</h4>
                                    <p>内容をより分かりやすく伝えるために、文書の分野やジャンルに従って文の組み立てを修正します。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">The students don't enjoy
                                            <span class="wrongText">to go</span>
                                            <span class="rightText">going</span> over the same rules again and again.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>単語の選択</h4>
                                    <p>意味が明確でない単語を、より適切な単語に置き換えます。それにより、伝えたい内容がさらに正確に伝わります。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">One of the reasons is
                                            <span class="wrongText">because</span>
                                            <span class="rightText">that</span> the fabrication cost
                                            <span class="wrongText">for</span>
                                            <span class="rightText">of</span> steel members depends upon the material.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>語法、文体</h4>
                                    <p>語句を修正し、文体をフォーマルに整えます。読み手にしっかりと伝わる、はっきりとした英文が作れます。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">However, his method is novel and is
                                            <span class="wrongText">very much</span>
                                            <span class="rightText">considerably</span> different from the classical method.
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>アメリカ英語/イギリス英語</h4>
                                    <p>アメリカ/イギリス英語のいずれかを指定すれば、読者やジャーナルの投稿規程に合わせて表記を整えます。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">The upper limbs of the patient were
                                            <span class="wrongText">paralysed</span>
                                            <span class="rightText">paralyzed.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>文脈に即したスペル</h4>
                                    <p>文脈に即したスペルチェック機能では、その分野で使われる正しい単語/スペルでの校正を行います。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">The
                                            <span class="wrongText">Bonferoni</span>
                                            <span class="rightText">Bonferroni</span> test was used to check for statistical significance.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider section-pd pb-0">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title text-center">
                        <h2>公開に耐える、洗練された英語に校正</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinkaは、文体、表現、言い回しなどを学術論文の基準に見合うよう洗練します。ストレスフリーで、論文用の英作文ができるのです。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="publishEnhancements" class="carousel slide carousel-arrows" data-ride="carousel">
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators1 carousel-indicators">
                                    <li data-target="#publishEnhancements" data-slide-to="0" class="active">
                                        <span></span>
                                        スタイル
                                        ガイドへの
                                        準拠
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="1">
                                        <span></span>
                                        単語数削減
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="2">
                                        <span></span>
                                        適切な
                                        言葉遣い
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="3">
                                        <span></span>
                                        明確な表現
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="4">
                                        <span></span>
                                        適正な
                                        専門用語
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="5">
                                        <span></span>
                                        学術的な
                                        文体
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>スタイルガイドへの準拠</h4>
                                    <p>AMAやAPAといったスタイルガイドに即した語法を提案。目標のジャーナルに合わせたライティングも簡単です。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">The man
                                            <span class="wrongText">suffered from</span>
                                            <span class="rightText">had</span> chronic kidney disease.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>単語数削減</h4>
                                    <p>冗長な表現なども簡潔に修正。ジャーナルの規程単語数に合わせたライティングが容易になります。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">Bcl6 deficiency in T cells resulted in
                                            <span class="wrongText">the reduction of
                                            </span>
                                            <span class="rightText">reduced</span> mRNA expression.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>適切な言葉遣い</h4>
                                    <p>Trinkaは、意図するところではない偏見を批判されないよう、不適切な言葉遣いや偏向のある表現を検出し修正します。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">The
                                            <span class="wrongText">retarded children</span>
                                            <span class="rightText">children with mental retardation</span> were taken to a different facility.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>明確な表現</h4>
                                    <p>あいまいな表現をより具体的に、伝わりやすく修正して、より効果的な情報発信を可能にします。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">
                                            <span class="wrongText">Some studies</span>
                                            <span class="rightText">Studies</span> have shown that children not participating in co-curricular activities
                                            may not develop the necessary social skills in adulthood.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>適正な専門用語</h4>
                                    <p>その分野で使われる正しい専門用語を提案します。研究者を読み手とする論文でも安心です。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                            <span class="wrongText">transverse myelitis with long spinal cord lesions
                                            </span>
                                            <span class="rightText">longitudinally extensive transverse myelitis.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>学術的な文体</h4>
                                    <p>英文を学術的でフォーマルな文体にします。読者も納得のアカデミックなライティングも難しくありません。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">Children actively engage in activities
                                            <span class="wrongText">like</span>
                                            <span class="rightText">such as</span> outdoor games, skits, and other team activities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-xl-7">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="publishEnhancements" class="carousel slide" data-ride="carousel">
                            <!-- Indicators -->
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators">
                                    <li data-target="#publishEnhancements" data-slide-to="0" class="active">
                                        <span></span>
                                        スタイル
                                        <br />ガイドへの
                                        <br />準拠
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="1">
                                        <span></span>
                                        単語数削減
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="2">
                                        <span></span>
                                        適切な
                                        <br />言葉遣い
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="3">
                                        <span></span>
                                        明確な表現
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="4">
                                        <span></span>
                                        適正な
                                        <br />専門用語
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="5">
                                        <span></span>
                                        学術的な
                                        <br />文体
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>スタイルガイドへの準拠</h4>
                                    <p>AMAやAPAといったスタイルガイドに即した語法を提案。目標のジャーナルに合わせたライティングも簡単です。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">The man
                                            <span class="wrongText">suffered from</span>
                                            <span class="rightText">had</span> chronic kidney disease.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>単語数削減</h4>
                                    <p>冗長な表現なども簡潔に修正。ジャーナルの規程単語数に合わせたライティングが容易になります。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">Bcl6 deficiency in T cells resulted in
                                            <span class="wrongText">the reduction of
                                            </span>
                                            <span class="rightText">reduced</span> mRNA expression.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>適切な言葉遣い</h4>
                                    <p>Trinkaは、意図するところではない偏見を批判されないよう、不適切な言葉遣いや偏向のある表現を検出し修正します。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">The
                                            <span class="wrongText">retarded children</span>
                                            <span class="rightText">children with mental retardation</span> were taken to a different facility.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>明確な表現</h4>
                                    <p>あいまいな表現をより具体的に、伝わりやすく修正して、より効果的な情報発信を可能にします。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">
                                            <span class="wrongText">Some studies</span>
                                            <span class="rightText">Studies</span> have shown that children not participating in co-curricular activities
                                            may not develop the necessary social skills in adulthood.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>適正な専門用語</h4>
                                    <p>その分野で使われる正しい専門用語を提案します。研究者を読み手とする論文でも安心です。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                            <span class="wrongText">transverse myelitis with long spinal cord lesions
                                            </span>
                                            <span class="rightText">longitudinally extensive transverse myelitis.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>学術的な文体</h4>
                                    <p>英文を学術的でフォーマルな文体にします。読者も納得のアカデミックなライティングも難しくありません。</p>
                                    <div class="featuresExampleText">
                                        <p class="OpenSansFonts">Children actively engage in activities
                                            <span class="wrongText">like</span>
                                            <span class="rightText">such as</span> outdoor games, skits, and other team activities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-5">
                    <div class="spellcheck_heading">
                        <h2>公開に耐える、洗練された英語に校正</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinkaは、文体、表現、言い回しなどを学術論文の基準に見合うよう洗練します。ストレスフリーで、論文用の英作文ができるのです。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section section-pd pb-0">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title mb-0 text-center">
                        <h2>著者に必要な機能一式がここに</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
        </div>

        <section class="section-pd list-wrapper-style-2">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>著者に必要な機能一式がここに</h3>
                            <p>
                                iThenticate® が誇る最先端のテキスト類似性検出アルゴリズムと、すべての学問領域をカバーする最大級の有料出版物データベースによる高品質の盗用・剽窃チェックをご提供します。
                            </p>
                            <a [routerLink]="['/features/plagiarism-check']" class="link-text">
                                もっと詳しく
                                <img src="../../../assets/images/ReadMoreArrow-blue.png" alt="アイコン">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="../../../assets/images/features/pc-check.jpg" alt="著者に必要な機能一式がここに">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>ファイルを自動で英文校正</h3>
                            <p>ご自宅、勤務先などいつもの環境で作成した英文をWordファイルでアップロードすれば、Trinkaが数分で自動的に英文校正。あとは、変更履歴付きの校正済みファイルをダウンロードするだけです。</p>
                            <a href="https://www.trinka.ai/jp/features/auto-file-edit" class="link-text">
                                もっと詳しく
                                <img src="../../../assets/images/ReadMoreArrow-blue.png" alt="アイコン">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="../../../assets/images/features/proofread.svg" alt="英文校正">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>出版適正チェック</h3>
                            <p>Trinkaの出版適正チェック機能では、ジャーナルとの相性から、倫理面・コンプライアンスのチェックなど20以上のチェックポイントで文章を査定し、論文受理の可能性を高めます。
                            </p>
                            <a href="https://www.trinka.ai/jp/features/publication-readiness-checks" class="link-text">
                                もっと詳しく
                                <img src="../../../assets/images/ReadMoreArrow-blue.png" alt="アイコン">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="../../../assets/images/features/s3.svg" alt="出版適正チェック">
                        </div>
                        <!-- <div class="list-wrapper-image">
                            <div class="toolbox_img_content publication_checks_icons publication_checks_section">
                                <ul>
                                    <li>
                                        <div class="checks_icons">
                                            <img src="../../../assets/images/JournalScope.svg" alt="scope">
                                        </div>
                                        <h3>Journal Scope Match</h3>
                                        <span>2 Checks</span>
                                    </li>
    
                                    <li>
                                        <div class="checks_icons">
                                            <img src="../../../assets/images/TechnicalCompliance.svg" alt="technical">
                                        </div>
                                        <h3>Technical Compliances</h3>
                                        <span>3 Checks</span>
                                    </li>
    
                                    <li>
                                        <div class="checks_icons">
                                            <img src="../../../assets/images/EthicalCompliance.svg" alt="ethical">
                                        </div>
                                        <h3>Ethical Compliance</h3>
                                        <span>5 Checks</span>
                                    </li>
    
                                    <li>
                                        <div class="checks_icons">
                                            <img src="../../../assets/images/AuthorshipDetails.svg" alt="authorship">
                                        </div>
                                        <h3>Authorship Details</h3>
                                        <span>4 Checks</span>
                                    </li>
                                    <li>
                                        <div class="checks_icons">
                                            <img src="../../../assets/images/ReferenceDetails.svg" alt="reference">
                                        </div>
                                        <h3>Reference Details</h3>
                                        <span>1 Check</span>
                                    </li>
    
                                    <li>
                                        <div class="checks_icons">
                                            <img src="../../../assets/images/FirgureTable.svg" alt="FirgureTable">
                                        </div>
                                        <h3>Figures & Tables</h3>
                                        <span>2 Checks</span>
                                    </li>
    
                                    <li>
                                        <div class="checks_icons">
                                            <img src="../../../assets/images/ClinicalTrials.svg" alt="clinical trials">
                                        </div>
                                        <h3>Clinical Trial Information</h3>
                                        <span>1 Check</span>
                                    </li>
    
                                    <li>
                                        <div class="checks_icons">
                                            <img src="../../../assets/images/KeywordsAndSummary.svg" alt="keywords">
                                        </div>
                                        <h3>Keywords & Summary</h3>
                                        <span>2 Checks</span>
                                    </li>
                                    <i></i>
                                </ul>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </section>

        <!-- <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>Online<br/> Paraphraser <div class="beta-badge">NEW</div></h3>
                            <p>AI-powered paraphraser that understands your intent and offers suggestions to make your writing clear, coherent, and grammatically correct.
                            </p>
                            <a [routerLink]="['/features/paraphraser']" class="link-text">
                                もっと詳しく
                                <img src="../../../assets/images/ReadMoreArrow-blue.png" alt="アイコン">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="../../../assets/images/features/paraphraser.jpg" alt="publication">
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

        <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>もっと詳しく</h3>
                            <p>Trinkaの引用チェッカーは、研究の前提や論拠を弱める可能性のある引用を特定し、論文に信頼性のある参考文献を引用できるようにします。
                            </p>
                            <a [routerLink]="['/features/citation-checker']" class="link-text">
                                もっと詳しく
                                <img src="../../../assets/images/ReadMoreArrow-blue.png" alt="アイコン">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="../../../assets/images/features/s2.svg" alt="もっと詳しく">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>Journal Finder</h3>
                            <p>Identifies the right journal by comparing the concepts in your paper against millions of publications and publication trends.
                            </p>
                            <a [routerLink]="['/features/journal-finder']" class="link-text">
                                もっと詳しく
                                <img src="../../../assets/images/ReadMoreArrow-blue.png" alt="アイコン">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="../../../assets/images/features/s1.svg" alt="journal-finder">
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

        <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>用語統一チェック</h3>
                            <p>Trinkaなら、単語をつなぐハイフンの有無など英単語や語句の表記ゆれを一斉に検出・校正し、どれだけ長大な文書でもワンクリックで修正できます。</p>
                            <a [routerLink]="['/features/consistency-check']" class="link-text">
                                もっと詳しく
                                <img src="../../../assets/images/ReadMoreArrow-blue.png" alt="アイコン">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="../../../assets/images/features/Consistency-Check.svg" alt="用語統一チェック">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>マイ・ディクショナリー</h3>
                            <p>マイ・ディクショナリーに用語を追加すれば、Trinkaがそれをスペルミスと判断することはなくなります。マイ・ディクショナリーはProfile欄から確認・編集もできます。</p>
                            <a [routerLink]="['/features/personal-dictionary']" class="link-text">
                                もっと詳しく
                                <img src="../../../assets/images/ReadMoreArrow-blue.png" alt="アイコン">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="../../../assets/images/features/Personal-Dictionary.svg" alt="マイ・ディクショナリー" />
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>変更履歴ファイルのダウンロード</h3>
                            <p>残したい変更履歴だけを付けたファイルをダウンロードして、それを元に改めて文章を推敲し、最終稿を作成できます。</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="../../../assets/images/DownloadFileTrackChanges.svg" alt="変更履歴ファイルのダウンロード" />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>変更提案を一括承認／すべて無視</h3>
                            <p>Trinkaの修正提案を一括して承認したり、無視したりすることができます。ファイル内に同じ提案が複数あっても、何度も変更／無視する必要はありません。
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <div class="toolbox_img_content publication_checks_section pd_after">
                                <div class="personal_dictionary_section">
                                    <div class="personal_dic_left_text">
                                        <h2>Spelling
                                            <b>
                                                <i class="fa fa-plus"></i>Add to dictionary</b>
                                        </h2>
                                        <div class="personal_dic_text_section">
                                            <p class="personal_wrong_text">nanotubol</p>
                                            <img src="../../../assets/images/spacingArrow.png" alt="アイコン" />
                                            <p class="personal_right_text">nanotubes</p>
                                        </div>
                                        <div class="acceptAll_buttons_sections">
                                            <p>Accept for all similar alerts</p>
                                            <i>
                                                <img src="../../../assets/images/info.svg" alt="アイコン">
                                            </i>
                                        </div>
                                        <p>Please check the spelling</p>
                                    </div>
                                    <div class="consistency_left_side">
                                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        <ul>
                                            <li>
                                                <img src="../../../assets/images/Consistency_delete_icon.svg" alt="消去" title="Delete" style="width: 22px;">
                                            </li>
                                            <li class="acceptAll_rejectAll">
                                                <img src="../../../assets/images/AcceptAll_consistencyCheks.svg" alt="アイコン" title="Ignore for all similar aterls" style="width: 22px;">
                                            </li>
                                            <li>
                                                <img src="../../../assets/images/consistency_dislike_icon.svg" alt="アイコン" title="Incorrect suggestions" style="width: 20px;">
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>


    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">今すぐお試しください</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">無料で登録する</a>
                        <!-- <a [routerLink]="['/grammar-checker']" class="white-btn">Try a Demo</a> -->
                    </div>
                </div>
            </div>  
        </div>
    </div>
</div>